import CrossFilledIcon from '@shared/assets/icons/cross/filled.svg';
import NotificationEnabledIcon from '@shared/assets/icons/notification/enabled.svg';
import PlusFilledIcon from '@shared/assets/icons/plus/filled.svg';
import { MBImageURISource } from '@shared/components/image';
import { MBBaseSystemMessage } from '@shared/scenes/chat/thread/components/message/system/base';
import { MBSystemMessageProps } from '@shared/scenes/chat/thread/components/message/system/index';
import { Colors } from '@shared/styles';
import { API } from '@shared/types/api';

const iconColorByMessageType: Partial<Record<API.EntityEventType, string>> = {
  CARD_CREATED: Colors.blue.light,
  CARD_UPDATED: Colors.blue.light,
  CARD_DELETED: Colors.red.primary,
  CARD_REMINDER_SENT: Colors.red.primary,
};

const iconByMessageType: Partial<Record<API.EntityEventType, MBImageURISource>> = {
  CARD_CREATED: PlusFilledIcon,
  CARD_UPDATED: PlusFilledIcon,
  CARD_DELETED: CrossFilledIcon,
  CARD_REMINDER_SENT: NotificationEnabledIcon,
};

export function getIconColor(message: API.ChatMessageFragment): string {
  return iconColorByMessageType[message.subType ?? ''];
}

export function getIcon(message: API.ChatMessageFragment): MBImageURISource {
  return iconByMessageType[message.subType ?? ''];
}

export function Card({ message, ...otherProps }: MBSystemMessageProps) {
  return (
    <MBBaseSystemMessage
      {...otherProps}
      icon={getIcon(message as any)}
      color={getIconColor(message as any)}
      text={message.content}
      date={message.createdAt}
    />
  );
}
